import React from "react"
import { Jumbotron, HeadNotification } from "../../components"
import WhoWeAre from "./WhoWeAre"
import TeamSection from "./TeamSection"
import BannerAboutUs from "./BannerAboutUs"
import bgimage from "../../assets/img/bgimage.png"
import { mission } from "./data.json"

function AboutUs() {
  return (
    <>
      <Jumbotron bgImage={bgimage}>
        <BannerAboutUs />
      </Jumbotron>
      <HeadNotification />
      <WhoWeAre mission={mission} />
      <TeamSection />
    </>
  )
}

export default AboutUs
